import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { StringValidator } from 'src/core/validators/shared/string.validator';

@Component({
    selector: 'ca-genesys-gir-integration-settings',
    templateUrl: './genesys-gir-integration-settings.component.html',
    styleUrls: ['./genesys-gir-integration-settings.component.scss'],
    standalone: false
})
export class GenesysGIRIntegrationSettingsComponent implements OnInit {
  form: FormGroup;

  private readonly prefix = 'GenesysGIRIntegration';
  private readonly sourceName = `${this.prefix}.SourceName`;
  private readonly startDate = `${this.prefix}.StartDate`;

  constructor(
    private fb: FormBuilder,
    private config: ConfigStateService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.form = this.fb.group({
      sourceName: this.fb.group({
        name: this.sourceName,
        value: [
          this.config.getSetting(this.sourceName),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      startDate: this.fb.group({
        name: this.startDate,
        value: [
          this.config.getSetting(this.startDate),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      })
    });
  }

  ngOnInit(): void {}

  onSubmitForm(eventArgs): void {
    if (!this.form.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.form.get('sourceName').get('name').value,
      settingValue: this.form.get('sourceName').get('value').value,
    });

    settings.push({
      settingName: this.form.get('startDate').get('name').value,
      settingValue: this.form.get('startDate').get('value').value,
    });
    
    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
